import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 業務選擇 PostBack 參數介面
 */
export interface IBusinessSelectionPostBackParams {
    /** 業務選擇列表 */
    businessesList: number[];
    /** 上傳項目選擇列表 */
    uploadItemList: number[];
}

/**
 * 業務選擇 - 提交選擇的業務項目 API
 *
 * @description 提交用戶選擇的上傳項目到 Session
 * @param params 業務選擇參數
 * @returns Promise<GeneralResp>
 */
const BusinessSelectionPostBack = (params: IBusinessSelectionPostBackParams): Promise<GeneralResp> => {
    const url = RouteUrlList.API_BusinessSelectionPostBack.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return ApiClient.post(url, params, config).then((res: AxiosResponse<GeneralResp>) => {
        return res.data;
    });
};

export default BusinessSelectionPostBack;
